import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { DriversService } from '../../drivers/drivers-service/drivers-service';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { takeUntil } from 'rxjs/operators';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import * as moment from "moment-timezone";
import { DriverLoadV2Component } from '../driver-load-v2/driver-load-v2.component';
import { AssigTripsService } from '../assigntrips-service/assigntrips-service';
import { sweetAlert } from 'src/app/utils/swal';
import { LevelOfServiceService } from '../../level-of-service/service/level-of-service.service';
import { CorporateService } from '../../corporate-user/corporate-service/corporate-service';
import { StaffService } from '../../staffs/staff-service/staff.service';
import { ServiceAreasService } from '../../service-areas/service-areas-service/service-areas.service';
import { checkRole } from 'src/app/utils/utils.common';
import { ViolationService } from '../../violations-sets/violation-service/violation.service';
import { SocketService } from 'src/app/service/socket-service/socket-service.service';
import { Events } from 'src/app/utils/event-utils';
import { BreakModalService } from 'src/app/modals/break-modal/break-modal-service/break-modal.service';
import { ActivatedRoute } from '@angular/router';
import { DriverLoadV3Component } from '../driver-load-v3/driver-load-v3.component';
import { DriverLoadV4Component } from '../driver-load-v4/driver-load-v4.component';

@Component({
  selector: 'app-driver-load-wrapper',
  templateUrl: './driver-load-wrapper.component.html',
  styleUrls: ['./driver-load-wrapper.component.css']
})
export class DriverLoadWrapperComponent implements OnInit, OnDestroy {
  @ViewChild('driverLoadV2', { static: false }) dl_v2: DriverLoadV2Component;
  @ViewChild('driverLoadV3', { static: false }) dl_v3: DriverLoadV3Component;
  @ViewChild('driverLoadV4', { static: false }) dl_v4: DriverLoadV4Component;
  wrapper = 'driverLoad';
  version = '2';

  constructor(
    private assignTripService: AssigTripsService,
    private levelOfServiceService: LevelOfServiceService,
    private corporateService: CorporateService,
    private driverService: DriversService,
    private staffService: StaffService,
    private serviceArea: ServiceAreasService,
    private violatioServie: ViolationService,
    private socketService: SocketService,
    private breakService : BreakModalService,
    private activatedRoute: ActivatedRoute
  ) { 
  }

  ngOnInit() {
    this.activatedRoute.params.pipe(takeUntil(componentDestroyed(this))).subscribe(params => {
      const param = params['version'];
      if (param && param === 'v2') {
        this.version = '3';
      } else if (param && param === 'v3') {
        this.version = '4';
      } else {
        this.version = '2';
      }
    });
  }

  get dl(): any {
    if (this.version === '2') return this.dl_v2;
    if (this.version === '3') return this.dl_v3;
    if (this.version === '4') return this.dl_v4;
    return this.dl_v2;
  }

  getLevelOfService() {
    this.levelOfServiceService
      .getLevelOfServices({ status: 'active' })
      .subscribe(data => {
        if (data) {
          this.dl.getLevelOfService(data);
        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  getSpaceTypes() {
    this.levelOfServiceService
      .getSpaceTypes({ status: 'active' })
      .subscribe(data => {
        if (data) {
          this.dl.getSpaceTypes(data);
        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  getCorporate() {
    this.corporateService
      .getCorporateUsers('active')
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.dl.getCorporate(data);
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  getStaffList() {
      const queryParams = {
    accountStatus: 'active'
    }
    this.staffService
      .getStaffList(queryParams)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.dl.getStaffList(data);
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  getServiceAreas() {
    this.serviceArea.getServiceAreas({ status: 'active' })
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.dl.getServiceAreas(data);
          }
        },
        (err) => {
          sweetAlert("Error", err, "error", "Ok");
        }
      );
  }

  getDrivers(data) {
    this.driverService
      .getDrivers(data.userId, data.endPoint, true)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.dl.getDriverList(data);
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  getAllTrips(payload) {
    this.assignTripService
      .getOutstandingTrips(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.dl.getAllTrips(data);
        }
      })
  }

  getDriverTimelines(queryString) {
    this.driverService
      .getDriverTimelines(queryString)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        console.log("data",data)
        this.dl.getDriverTimelines(data);
      });
  }

  processBucket(payload) {
    this.assignTripService
      .updateTrip(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.dl.processBucket(data);
        } else if (data) {
          sweetAlert('Error', data, 'warning', 'OK');
        }
      });
  }

  getNearbyDriver(payload) {
    this.driverService
      .getNearbyDrivers(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.dl.getNearbyDriversRes(data);
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  getViolationData() {
    this.violatioServie.getViolationData().subscribe((data) => {
      if (data) {
        this.dl.getViolationData(data);
      }
    })
  }

  cancelTrip(payload) {
    this.assignTripService
      .removeTrip(payload, payload._id)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.dl.cancelTrip(payload, data);
        }
      });
  }

  driverBreak(payload) {
    this.breakService
    .addDriverBreak(payload).pipe(takeUntil(componentDestroyed(this)))
    .subscribe(data => {
      if (data) {
        this.dl.onBreakModelClose();
      }
    }, err => {
      sweetAlert('Error', err, 'warning', 'OK');
    });
  }

  ngOnDestroy() {
  }
}
